import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {CurveInfo} from "#template/interface-descriptors"
import {ObjectFT} from "#template/nodes/object/fundamental"
import {curveMarker} from "#template/nodes/object/curve/marker"

export {curveLike, curveLikeMarker, isCurveLikeNode, isCurveLikeNodeClass} from "#template/nodes/object/curve/marker"
export type {CurveLikeNode} from "#template/nodes/object/curve/marker"

export const CurveFT = createFundamentalType({
    name: "Curve",
    marker: curveMarker,
    parent: ObjectFT,
    InfoClass: CurveInfo,
    icon: "far fa-scribble",
})

@registerFundamentalNode(CurveFT, "Likes")
export class CurveLikes extends CurveFT.Likes {}

@registerFundamentalNode(CurveFT, "Switch")
export class CurveSwitch extends CurveFT.Switch {}

@registerFundamentalNode(CurveFT, "Input")
export class CurveInput extends CurveFT.Input {}

@registerFundamentalNode(CurveFT, "Output")
export class CurveOutput extends CurveFT.Output {}

@registerFundamentalNode(CurveFT, "Export")
export class CurveExport extends CurveFT.Export {}
